import React from 'react'

import { NavLink as Link } from 'react-router-dom'

import SVGLoader from './SVGLoader'

import './ItemMenu.css'

export default function ItemMenu(props) {
    const e = props.item
    const i = props.index
    const params = props.params
    return (
        <>
            {e.urlServico && e.urlServico.includes('http') ? (
                <li className="transparencia-portal-menu-item-abre-externo">
                    <>
                        <a id={'menu-' + i} className={'transparencia-portal-menu-item menu-' + i} href={e.urlServico} target="blank">
                            <SVGLoader className="imagemItemMenu" imagem={`icones/${e.imagem || 'settings.svg'}`} fallback="icones/settings.svg" />
                            {e.tituloMenu}
                        </a>
                        <p className="abreNovaAba">(Abre em nova aba)</p>
                    </>
                </li>
            ) : (
                <li>
                    <Link
                        id={'menu-' + i}
                        className={'transparencia-portal-menu-item menu-' + i}
                        to={e.urlServico ? e.urlServico : '/conteudoGrupo/' + btoa(encodeURIComponent(JSON.stringify(params)))}
                        onClick={() => props.toggleMenu()}
                    >
                        <SVGLoader className="imagemItemMenu" imagem={`icones/${e.imagem || 'settings.svg'}`} fallback="icones/settings.svg" />
                        {e.tituloMenu}
                    </Link>
                </li>
            )}
        </>
    )
}
